import { css } from '@emotion/core';
import { MEDIA_BREAKPOINTS } from '../../../../common/services/breakpoints';

export const filterLogicAddButtonCSS = ({ colors }) => css`
    color: ${colors.blue60};
    background-color: transparent;
    all: unset;
    cursor: pointer;
    color: ${colors.blue60};
    white-space: nowrap;
    display: inline-flex;
    align-items: center;

    &:hover {
        text-decoration: underline;
    }

    &:active {
        text-decoration: underline;
        font-weight: bold;
    }

    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        padding-bottom: 1rem;
    }
`;

export const filterLogicLabelCSS = ({ colors }) => css`
    color: ${colors.textSecondary};
    font-weight: bold;
    display: inline-block;
`;

export const removeFilterLogicButtonContainerCSS = css`
    display: inline-block;
    float: right;
    padding-right: 1rem;
`;
export const filterLogicTextAreaContainerCSS = css`
    padding-top: 0.5rem;
    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        padding-bottom: 1rem;
    }
`;

export const filterLogicTextAreaCSS = css`
    font-family: Inter, Arial, Helvetica, sans-serif;
    overflow: auto;
    width: 95%;
    height: 5.8rem;
    border-radius: 0.5rem;
    resize: none;
    padding: 1rem;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const filterLogicErrorTextAreaCSS = ({ colors }) => css`
    font-family: Inter, Arial, Helvetica, sans-serif;
    overflow: auto;
    width: 95%;
    height: 5.8rem;
    border-radius: 0.5rem;
    resize: none;
    padding: 1rem;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-color: ${colors.redDark};
`;

export const filterLogicStringCSS = css`
    padding-left: 0.25rem;
`;

export const filterLogicLogsCSS = ({ colors, fontSizes }) => css`
    color: ${colors.redDark};
    font-size: ${fontSizes.extraSmall};
`;
